import {lazy} from "react";

export const ReportReceivedLazy = lazy(()=>import('./ReportReceived'))